<template>
  <form name="user" class="needs-validation" novalidate>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;
      <strong>{{ alert.message }}</strong>
      <br />
      {{ alert.reason }}
    </div>
    <div class="alert m-alert m-alert--default mb-3 mt-4" role="alert">
      <h5><i class="fas fa-info-circle"></i> Informações do Usuário</h5>
    </div>

    <div class="row mb-4" v-if="data.id">
      <div class="col-md-2">
        <label>ID Usuário</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder
            v-model="data.id"
            readonly="readonly"
          />
        </div>
      </div>
      <div class="col-md-4">
        <label for="status"> Status </label>
        <div class="input-group">
          <span
            class="m--font-success"
            v-if="data.status === 1"
            v-b-tooltip.hover
            :title="'Usuário Ativo'"
            >Ativo</span
          >
          <span
            class="m--font-warning"
            v-if="data.status === 0"
            v-b-tooltip.hover
            :title="'Usuário Inativo'"
            >Inativo</span
          >
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div :class="{ 'col-md-5': data.id, 'col-md-7': !data.id }">
        <div class="form-group" :class="{ 'has-danger': !data.name }">
          <label for="name">
            Nome
            <span class="m--font-danger">*</span>
          </label>
          <div class="input-group">
            <input
              id="name"
              type="text"
              ref="name"
              class="form-control m-input"
              placeholder
              v-model="data.name"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group" :class="{ 'has-danger': !data.email }">
          <label for="email">
            E-mail
            <span class="m--font-danger">*</span>
          </label>
          <div class="input-group">
            <input
              type="text"
              class="form-control m-input"
              name="email"
              id="email"
              placeholder
              v-model="data.email"
              required
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-2">
        <div class="form-group" :class="{ 'has-danger': !data.password }">
          <label for="password">
            Perfil
            <span v-if="!data.id" class="m--font-danger">*</span>
          </label>
          <div class="input-group">
            <SelectRoles
              :selected="data.role"
              :first="'Selecione um Perfil...'"
              @change="onChangeStatus($event)"
              class="form-control m-input"
              v-model="data.role"
            />
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group" :class="{ 'has-danger': !data.password }">
          <label for="password">
            Senha
            <span v-if="!data.id" class="m--font-danger">*</span>
          </label>
          <div class="input-group">
            <input
              type="password"
              id="password"
              ref="password"
              class="form-control m-input"
              placeholder
              v-model="data.password"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group" :class="{ 'has-danger': !data.c_password }">
          <label for="c_password">
            Confirma Senha
            <span v-if="!data.id" class="m--font-danger">*</span>
          </label>
          <div class="input-group">
            <input
              type="password"
              class="form-control m-input"
              name="c_password"
              id="c_password"
              placeholder
              v-model="data.c_password"
              required
            />
          </div>
        </div>
      </div>
    </div>

    <hr class="row mt-5 mb-3" />
    <div class="row">
      <div class="col-md-12 text-right">
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.name.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.name"
          >
            O campo
            <strong>Nome</strong> é obrigatório *
          </a>
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.email.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.email"
          >
            O campo
            <strong>E-mail</strong> é obrigatório *
          </a>
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.email.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.email"
          >
            O campo
            <strong>Perfil</strong> é obrigatório *
          </a>
        </p>
        <p class="p-0 m-0" v-if="userId === 'add'">
          <a
            href="#"
            @click.prevent="$refs.email.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.email"
          >
            O campo
            <strong>Senha</strong> é obrigatório *
          </a>
        </p>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12 text-right">
        <button
          @click.prevent="saveForm()"
          class="btn"
          :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
          :disabled="!formIsValid"
        >
          <i class="fas fa-save" v-if="formIsValid"></i>
          <i class="fas fa-exclamation-triangle" v-else></i>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import SelectRoles from '@/components/forms/SelectRoles';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin],
  name: 'UserSaveForm',
  components: { SelectRoles },
  data() {
    return {
      doctype: 0,
      data: {
        contract_type: 0,
        audit: {
          field: [],
          user: false,
        },
      },
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  methods: {
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;

      if (alertEl) {
        alertEl.scrollIntoView();
      }

      const { data } = this;
      let url = `${baseApiUrl}/v1/user/register`;

      if (data.id) {
        url = `${baseApiUrl}/v1/user/edit`;
      }

      axios
        .post(url, data)
        .then((res) => {
          this.logMessageForm(res);
          this.data = data;
        })
        .catch((error) => this.logMessageFormFailed(error.response));
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/user/data/${this.userId}`;
      axios(url).then((res) => {
        this.data = res.data;
      });
    },
    callData() {
      this.getDatas();
    },
    onChangeStatus(role) {
      this.data.role = role;
    },
  },
  computed: {
    userId() {
      return this.$store.state.showUserSave;
    },
    formIsValid() {
      if (
        this.data.name &&
        this.data.email &&
        this.data.role &&
        (!this.data.password ||
          (this.data.password && this.data.password === this.data.c_password)) &&
        (this.userId !== 'add' ||
          (this.userId === 'add' &&
            this.data.password &&
            this.data.password === this.data.c_password))
      ) {
        return true;
      }
      return false;
    },
  },
  beforeMount() {
    if (this.userId && this.userId !== 'add') {
      this.callData();
    }
  },
};
</script>

<style></style>
